import { render, staticRenderFns } from "./update-custom-field-settings.vue?vue&type=template&id=182bf527&scoped=true"
import script from "./update-custom-field-settings.vue?vue&type=script&lang=js"
export * from "./update-custom-field-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182bf527",
  null
  
)

export default component.exports